var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from "classnames";
import React, { forwardRef, } from "react";
import Link from "../Link";
const SkipToContent = forwardRef((_a, ref) => {
    var { contentId = "gerudo-main", text, children, className } = _a, props = __rest(_a, ["contentId", "text", "children", "className"]);
    if (!text && !children) {
        // eslint-disable-next-line no-console
        console.error("SkipToContent requires the `text` or `children` prop.");
    }
    if (text && children) {
        // eslint-disable-next-line no-console
        console.warn("SkipToContent should use only `text` or `children` prop, not both.");
    }
    return (React.createElement(Link, Object.assign({}, props, { href: `#${contentId}`, className: classNames("visuallyhidden", "gerudo-skip-to-content", className), ref: ref }), text || children));
});
SkipToContent.displayName = "SkipToContent";
export default SkipToContent;
export { SkipToContent };
//# sourceMappingURL=index.js.map